import supportLinks from '@core/constants/supportLinks'

export default [
  {
    title: 'Dashboard',
    icon: 'GridIcon',
    route: 'dashboard',
    permissions: {
      companyUser: ['view-any shipment'],
      user: ['view-any shipment'],
    },
  },
  {
    title: 'Shipments',
    route: 'shipments',
    icon: 'FileIcon',
    permissions: {
      companyUser: ['view-any shipment'],
      user: ['view-any shipment'],
    },
  },
  {
    title: 'Parcels',
    route: 'parcels',
    icon: 'PackageIcon',
    permissions: {
      companyUser: ['view-any shipment'],
      user: ['view-any shipment'],
    },
  },
  {
    title: 'Reports',
    icon: 'ActivityIcon',
    permissions: {
      companyUser: ['view report'],
      user: ['view report'],
    },
    children: [
      {
        title: 'Parcels',
        route: 'reports',
        icon: 'PieChartIcon',
      },
      {
        title: 'Customs duty',
        route: 'reports-customs-duty',
        icon: 'DollarSignIcon',
      },
    ],
  },
  {
    title: 'Events history',
    route: 'eventsHistory',
    icon: 'ArchiveIcon',
    permissions: {
      companyUser: ['view-any shipment'],
      user: ['view-any shipment'],
    },
  },
  {
    header: 'Physical handling',
    permissions: {
      companyUser: ['do arrival scans'],
      user: ['do arrival scans'],
    },
  },
  {
    title: 'Arrival Scan',
    route: 'arrival-scan',
    icon: 'CheckIcon',
    permissions: {
      companyUser: ['do arrival scans'],
      user: ['do arrival scans'],
    },
  },
  {
    header: 'Settings',
    permissions: {
      companyUser: ['view company'],
      user: ['view company'],
    },
  },
  {
    title: 'Companies',
    route: 'companies',
    permissions: {
      user: ['view company'],
    },
    icon: 'BookOpenIcon',
  },
  {
    title: 'Users',
    route: 'users',
    icon: 'UsersIcon',
    permissions: {
      companyUser: ['view user'],
      user: ['view user'],
    },
  },
  {
    title: 'Commodities',
    route: 'special-commodities',
    icon: 'LockIcon',
    permissions: {
      companyUser: ['view special-commodities'],
      user: ['view special-commodities'],
    },
  },
  {
    title: 'Warehouses',
    route: 'warehouses',
    icon: 'ArchiveIcon',
    permissions: {
      companyUser: ['view warehouse'],
      user: ['view warehouse'],
    },
  },
  {
    title: 'Carriers',
    route: 'carriers',
    icon: 'TruckIcon',
    permissions: {
      companyUser: ['view carrier'],
      user: ['view carrier'],
    },
  },
  {
    header: 'Help',
    permissions: {
      companyUser: ['view help'],
      user: ['view help'],
    },
  },
  {
    title: 'Support',
    icon: 'HelpCircleIcon',
    permissions: {
      companyUser: ['view help'],
      user: ['view help'],
    },
    children: [
      {
        title: 'Support center',
        href: supportLinks.supportCenter,
        icon: 'HelpCircleIcon',
      },
      {
        title: 'Manifest templates',
        href: supportLinks.manifestTemplates,
        icon: 'FileTextIcon',
      },
    ],
  },
  {
    header: 'Advanced',
    permissions: {
      companyUser: ['invoicing-tryout', 'view customs-messages'],
      user: ['invoicing-tryout', 'view customs-messages'],
    },
  },
  {
    title: 'Message log',
    route: 'customs-log',
    icon: 'EyeIcon',
    permissions: {
      companyUser: ['view customs-messages'],
      user: ['view customs-messages'],
    },
  },
  {
    title: 'Invoicing',
    route: 'invoicing',
    icon: 'DollarSignIcon',
    permissions: {
      companyUser: ['invoicing-tryout'],
      user: ['invoicing-tryout'],
    },
    children: [
      {
        title: 'Try out',
        route: 'invoicing-tryout',
        icon: 'PieChartIcon',
      },
      {
        title: 'Invoices',
        route: 'invoices',
        icon: 'ActivityIcon',
      },
    ],
  },
  {
    title: 'Valid HS codes',
    route: 'valid-hs-codes',
    icon: 'FileTextIcon',
    roles: ['Feeport Admin'],
  },
  {
    title: 'Ongoing Shipments',
    icon: 'WindIcon',
    route: 'ongoing-shipments-dashboard',
    permissions: {
      companyUser: ['view customs-messages'],
      user: ['view customs-messages'],
    },
  },
]
